module.exports = __webpack_public_path__ + "static/media/konveksi.623f7971.png";